var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVipIconAdultcrush(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.782 1.207L1.53 4.227a3 3 0 00.256 3.887l9.757 10.017a3 3 0 004.243.055L26.128 8.104a3 3 0 00.321-3.928L24.27 1.22A3 3 0 0021.856 0H6.187a3 3 0 00-2.405 1.207z",
    fill: "var(--cta, #FF4A4A)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.184 11.864V4h2.966c.522 0 .92.025 1.196.075.387.064.71.188.971.37.261.179.47.431.628.757.16.325.241.683.241 1.072 0 .67-.213 1.236-.638 1.7-.426.462-1.195.693-2.307.693h-2.017v3.197h-1.04zm1.04-4.125h2.033c.673 0 1.15-.125 1.433-.376.282-.25.423-.602.423-1.056 0-.33-.084-.61-.252-.843a1.15 1.15 0 00-.654-.466c-.175-.047-.5-.07-.971-.07h-2.012v2.81zM13.305 11.864V4h1.04v7.864h-1.04zM8.047 11.864L5 4h1.126L8.17 9.713c.165.458.302.887.413 1.287.122-.429.263-.858.424-1.287L11.131 4h1.062l-3.079 7.864H8.047z",
    fill: "var(--text-buttons, #F5F5F5)"
  })));
}
export default SvgVipIconAdultcrush;